import { DataFormatToggle } from '../dataLocker/DataFormatToggle';
import { ShowRankToggle } from '../dataLocker/ShowRankToggle';
import { SettingsPanel } from './SettingsPanel';

export const AppearanceSettingsPanel = () => (
  <SettingsPanel>
    <DataFormatToggle />
    <ShowRankToggle />
  </SettingsPanel>
);
